<template>
  <div class="alert alert-dismissible" :class="'alert-' + type">
    <button type="button" class="close" data-dismiss="alert">&times;</button>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    type: String
  },
}
</script>
